'use strict'

{clockTimeLeft, textTimeLeft, progressComplete} = require '../../common/helpers'

module.exports = JuiceProgramModel = Backbone.Model.extend

  constructor: (juiceInfo = {}) ->
    {juiceProgramStartTime, juiceProgramEndTime} = juiceInfo
    @startAt = new Date(juiceProgramStartTime) if juiceProgramStartTime?
    @endAt = new Date(juiceProgramEndTime) if juiceProgramEndTime?
    Backbone.Model.apply this, arguments

  timeLeft: ->
    if (clockTime = clockTimeLeft @endAt) and (textTime = textTimeLeft @endAt) and @startAt?
      progress = progressComplete @startAt, @endAt
      {clockTime, progress, textTime}
